import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../app";

interface modelDisplay {
  model_name: string;
  model: string;
  mode: string;
}

interface modelMap {
  name: string;
  icon: any;
}

// Define a model for the slice state
interface modelState {
  model: string;
  models: { [index: string]: modelDisplay[] };
  imagemodel: string;
  modelmaps: { [index: string]: modelMap };
}

// Define the initial state using that model
const initialState: modelState = {
  model: "",
  models: {
    chat: [],
    image: [],
    multimodel: [],
    embeddings: [],
  },
  imagemodel: "",
  modelmaps: {},
};

export const modelSlice = createSlice({
  name: "model",
  // `createSlice` will infer the state model from the `initialState` argument
  initialState,
  reducers: {
    addModel: (state, action) => {
      return {
        ...state,
        model: action.payload,
      };
    },
    addModelsForKey: (state, action) => {
      return {
        ...state,
        models: action.payload,
      };
    },
    addImageModels: (state, action) => {
      return {
        ...state,
        imagemodel: action.payload,
      };
    },
    addModelMappings: (state, action) => {
      return {
        ...state,
        modelmaps: action.payload,
      };
    },
  },
});

export const { addModel, addModelsForKey, addImageModels, addModelMappings } =
  modelSlice.actions;

// Other code such as selectors can use the imported `RootState` model
export const getModelDetails = (state: RootState) => state.model;

export default modelSlice.reducer;
